import { FileModel } from 'services/EpdClient';
import styled from 'styled-components';
import Spinner from 'styles/spinner-left.styled';
import FileViewRow from './FileViewRow';
import { FileHelpBox } from '../help-boxes';

type TProps = {
  files?: FileModel[];
  className?: string;
  displayFilesCount?: number;
};

const FilesViewList = ({ files, className, displayFilesCount }: TProps) => {
  return (
    <Wrapper>
      {files?.map((f) => (
        <FileViewRow key={f.id} file={f} className={className} />
      ))}

      {Array.from({ length: Math.max(0, (displayFilesCount ?? 0) - (files?.length ?? 0)) }, (_, i) => (
        <FileHelpBox key={i} className={'compare-left-added'} style={{ borderRadius: 0 }}>
          <span>&nbsp;</span>
        </FileHelpBox>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  gap: 8px;

  .compare-left-updated,
  .compare-left-removed {
    border: 1px solid ${(props) => props.theme.colors.statusLabelRedText};
  }

  .compare-right-updated,
  .compare-right-added {
    border: 1px solid ${(props) => props.theme.colors.primaryGreen};
  }
`;

const SpinnerRow = styled.div`
  flex-direction: row;
  padding: 14px 16px;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  ${Spinner} {
    width: 1rem;
    height: 1rem;
  }
`;

export default FilesViewList;
